import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Services Map (ServicesMapScreen.tsx). Nhãn nhóm / trạng thái lịch / lọc nhanh lấy từ svcmap.ts và mã service, cảng, hãng không dịch.
addMessages('vi', {
  'ms.stOk': 'Còn hạn',
  'ms.stSoon': 'Sắp hết ≤ 7 ngày',
  'ms.stExp': 'Có hãng hết hạn',
  'ms.stNone': 'Chưa có giá',
  'ms.noWrite': 'Chưa bật ghi Services Map',
  'ms.vnPort': 'Cảng VN',
  'ms.carrier': 'Hãng',
  'ms.all': 'Tất cả',
  'ms.quick': 'Lọc nhanh service',
  'ms.search': 'Tìm service',
  'ms.searchTip': 'Mã service, tên, hãng, cảng',
  'svm.clear': 'Xoá lọc',
  'ms.matchN': '{a} / {b} service khớp',
  'ms.export': 'Xuất danh sách service',
  'ms.exportTip': 'Xuất danh sách service · rotation + hãng + T/T',
  'ms.noMatch': 'Không có service khớp',
  'ms.group': 'Nhóm tuyến',
  'ms.hCodeTip': 'Mã service · rê chuột xem tên đầy đủ, T/T, khoá hồ sơ',
  'ms.hCarTip': 'Chip xanh = hãng khai thác tàu · chip xám = mua slot (VSA)',
  'ms.hRotTip': 'Chấm xanh đặc = cảng VN · chỉ ghi mã cảng VN, cảng đầu và cảng cuối · rê chuột lên chấm xem mã cảng',
  'ms.hLoopTip': 'Vòng quay, ngày',
  'ms.hDays': 'ngày',
  'ms.hShipsTip': 'Số tàu bố trí',
  'ms.hShips': 'tàu',
  'ms.hWeekTip': 'Chuyến mỗi tuần',
  'ms.hWeek': '/tuần',
  'ms.hWeekCol': '/Tuần',
  'ms.grpTip': '{a} service · {b} hãng',
  'ms.dueTip': '{n} service cần nhập lịch',
  'ms.stopped': 'Ngừng chạy',
  'ms.open': 'Mở service {code}',
  'ms.locked': 'đã khoá hồ sơ',
  'ms.unlocked': 'chưa khoá hồ sơ',
  'ms.schedTo': 'lịch đến {v}',
  'ms.noNew': 'không nhận lịch mới',
  'ms.days': '{n} ngày',
  'ms.carsOf': 'Hãng {v}',
  'ms.operator': 'khai thác tàu',
  'ms.slot': 'mua slot (VSA)',
  'ms.rotN': 'Rotation {n} cảng',
  'ms.loopN': 'Vòng {n} ngày',
  'ms.shipsN': '{n} tàu bố trí',
  'ms.perWeek': '1 chuyến / tuần',
  'ms.lane': 'Tuyến',
  'ms.liveTip': '{a} hãng có giá còn hạn / {b} hãng đã khai tuyến',
  'ms.price': 'Giá',
  'ms.ask': 'Hỏi',
  'ms.askPending': '{n} hỏi giá chờ',
  'ms.picTip': 'Phụ trách Pricing · {v}',
  'ms.unfollow': 'Bỏ theo dõi {v}',
  'ms.follow': 'Theo dõi {v}',
  'ms.followingTip': 'Đang theo dõi · lên lưới Freight Cost',
  'ms.followTip': 'Theo dõi (Follow)',
  'ms.searchLane': 'Tìm tuyến',
  'ms.lanesCount': '{a}/{b} tuyến',
  'ms.noLane': 'Không có tuyến khớp',
  'ms.noLaneD': 'Bỏ bớt bộ lọc.',
  'ms.laneOf': 'Tuyến {v}',
  'ms.view': 'Chế độ xem',
  'ms.lts': 'Lịch dài hạn',
  'ms.imp': 'Nhập & đồng bộ',
  'ms.density': 'Mật độ',
  'ms.std': 'Chuẩn',
  'ms.compact': 'Gọn',
  'ms.noti': 'Việc và thông báo · 3 mới',
  'svm.more': 'Thao tác khác',
  'ms.addLane': 'Thêm tuyến',
  'ms.pickFile': 'Chọn file lịch hãng',
  'ms.addSvc': 'Thêm service',
  'ms.nopermT': 'Chỉ Pricing xem Services Map',
  'ms.errT': 'Không tải được Services Map',
  'ms.emptyT': 'Chưa có service',
  'ms.nopermD': 'Xin quyền Pricing ở Cài đặt.',
  'ms.errD': 'Mất kết nối tới máy chủ.',
  'svm.retry': 'Thử lại',
});
addMessages('en', {
  'ms.stOk': 'Valid',
  'ms.stSoon': 'Expiring ≤ 7 days',
  'ms.stExp': 'Some carriers expired',
  'ms.stNone': 'No rate',
  'ms.noWrite': 'Writing Services Map is not enabled',
  'ms.vnPort': 'VN port',
  'ms.carrier': 'Carrier',
  'ms.all': 'All',
  'ms.quick': 'Quick service filter',
  'ms.search': 'Search services',
  'ms.searchTip': 'Service code, name, carrier, port',
  'svm.clear': 'Clear filters',
  'ms.matchN': '{a} / {b} services match',
  'ms.export': 'Export service list',
  'ms.exportTip': 'Export service list · rotation + carriers + T/T',
  'ms.noMatch': 'No matching services',
  'ms.group': 'Lane group',
  'ms.hCodeTip': 'Service code · hover for full name, T/T, profile lock',
  'ms.hCarTip': 'Blue chip = operating carrier · grey chip = slot buyer (VSA)',
  'ms.hRotTip': 'Solid blue dot = VN port · only VN ports, first and last ports are labelled · hover a dot for the port code',
  'ms.hLoopTip': 'Loop, days',
  'ms.hDays': 'days',
  'ms.hShipsTip': 'Ships deployed',
  'ms.hShips': 'ships',
  'ms.hWeekTip': 'Sailings per week',
  'ms.hWeek': '/week',
  'ms.hWeekCol': '/Week',
  'ms.grpTip': '{a} services · {b} carriers',
  'ms.dueTip': '{n} services need a schedule',
  'ms.stopped': 'Stopped',
  'ms.open': 'Open service {code}',
  'ms.locked': 'profile locked',
  'ms.unlocked': 'profile unlocked',
  'ms.schedTo': 'schedule until {v}',
  'ms.noNew': 'no new schedule',
  'ms.days': '{n} days',
  'ms.carsOf': 'Carriers {v}',
  'ms.operator': 'operating carrier',
  'ms.slot': 'slot buyer (VSA)',
  'ms.rotN': 'Rotation {n} ports',
  'ms.loopN': 'Loop {n} days',
  'ms.shipsN': '{n} ships deployed',
  'ms.perWeek': '1 sailing / week',
  'ms.lane': 'Lane',
  'ms.liveTip': '{a} carriers with valid rates / {b} carriers declared on the lane',
  'ms.price': 'Rate',
  'ms.ask': 'Ask',
  'ms.askPending': '{n} rate inquiries pending',
  'ms.picTip': 'Pricing owner · {v}',
  'ms.unfollow': 'Unfollow {v}',
  'ms.follow': 'Follow {v}',
  'ms.followingTip': 'Following · shown on the Freight Cost grid',
  'ms.followTip': 'Follow',
  'ms.searchLane': 'Search lanes',
  'ms.lanesCount': '{a}/{b} lanes',
  'ms.noLane': 'No matching lanes',
  'ms.noLaneD': 'Remove some filters.',
  'ms.laneOf': 'Lanes {v}',
  'ms.view': 'View',
  'ms.lts': 'Long-term schedule',
  'ms.imp': 'Import & sync',
  'ms.density': 'Density',
  'ms.std': 'Standard',
  'ms.compact': 'Compact',
  'ms.noti': 'Tasks and notifications · 3 new',
  'svm.more': 'More actions',
  'ms.addLane': 'Add lane',
  'ms.pickFile': 'Choose carrier schedule file',
  'ms.addSvc': 'Add service',
  'ms.nopermT': 'Only Pricing can view Services Map',
  'ms.errT': 'Could not load Services Map',
  'ms.emptyT': 'No services yet',
  'ms.nopermD': 'Request Pricing access in Settings.',
  'ms.errD': 'Lost connection to the server.',
  'svm.retry': 'Retry',
});
